// src/i18n/es/control.ts
// «Control page» (w7.u5) — route /control. Metric labels come verbatim from
// the API (`it.*`, never translated at runtime); only the page chassis and
// section titles are translated here.
export const control = {
  name: 'Control |||| Control',
  subtitle: 'Salud de dispositivos, incidencias y recepción de datos, para IT y soporte',

  sections: {
    deviceHealth: 'Salud de dispositivos',
    incidents: 'Incidencias',
    ingest: 'Recepción de datos y conciliación técnica',
    other: 'Otros indicadores',
  },

  help: {
    title: 'Control',
    description:
      'La página de Control (dispositivos e incidencias): disponibilidad y silencio de los dispositivos, fallos de periféricos y consumibles, incidencias con su tiempo de resolución, y los huecos en la recepción de datos que también alimentan la página de estado.',
    features: {
      list: 'Cada indicador lleva su sello de cobertura y frescura, o el remedio exacto cuando el dato no está disponible.',
    },
    tips: {
      property: 'Cambie de hotel arriba a la izquierda; el periodo por defecto son los últimos 30 días.',
    },
  },
};

export default control;
